import { fetchAPI } from '@/shared/lib/api/client';

import { ClaimReferralResponse, JoinReferralResponse, ReferralStats } from '../model/types';

export const referralApi = {
  async fetchStats(): Promise<ReferralStats> {
    const { data } = await fetchAPI.get<ReferralStats>('/user/referral-stats');
    return data;
  },

  async claim(): Promise<ClaimReferralResponse> {
    const { data } = await fetchAPI.post<ClaimReferralResponse>('/user/claim-referral');
    return data;
  },

  async joinReferral(referralCode: string): Promise<JoinReferralResponse> {
    const { data } = await fetchAPI.post<JoinReferralResponse>('/user/join-referral', {
      referral_code: referralCode,
    });
    return data;
  },
};
